import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import fetchWrapper from '../utils/httpClient';
import { API_SUPPORT_PORTAL_LOGIN, API_INVALIDATE_TOKEN } from '../utils/apis';

// Login thunk
export const login = createAsyncThunk('auth/login', async (credentials) => {
  try {
    const response = await fetchWrapper.post(API_SUPPORT_PORTAL_LOGIN, credentials);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
});

// Logout thunk
export const logout = createAsyncThunk('auth/logout', async () => {
  const token = localStorage.getItem('access_token');
  try {
    await fetchWrapper.post(API_INVALIDATE_TOKEN, { token });
    localStorage.removeItem('access_token');
    return;
  } catch (error) {
    throw new Error(error.message);
  }
});

const supportportalLoginSlice = createSlice({
  name: 'supportportalLogin',
  initialState: {
    user: null,
    loading: false,
    error: null,
    status: 'idle'
  },
  extraReducers: (builder) => {
    builder
      // Login-related handling
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.resdata;
        state.status = 'succeeded';
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.status = 'failed';
      })
      // Logout-related handling
      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.status = 'succeeded';
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.status = 'failed';
      });
  }
});

export default supportportalLoginSlice.reducer;